import { ACTION_TYPES } from 'src/modules/reducers/modal.reducer';

export const openModal = (options) => ({ type: ACTION_TYPES.OPEN, options });

export const closeModal = () => ({ type: ACTION_TYPES.CLOSE });

export const openNameRequiredDialog = () => ({ type: ACTION_TYPES.NAME_REQUIRED_OPEN });

export const closeNameRequiredDialog = () => ({ type: ACTION_TYPES.NAME_REQUIRED_CLOSE });
